<template>
  <div>
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(cadastrarClassificado)">
        <b-card header-tag="header" no-body v-if="!detalhes">
          <template #header>
            <b-row>
              <b-col cols="6">
                <header-sagres
                  titulo="Novo classificado"
                  breakpoint="xl"
                  class="text-left"
                />
              </b-col>
              <b-col cols="6">
                <b-button
                  size="sm"
                  @click="exibirModalImportacao = true"
                  class="float-right mx-2"
                >
                  <font-awesome-icon icon="cloud-upload" />
                  Importar Classificados
                </b-button>
                <b-button
                  type="submit"
                  variant="secondary"
                  size="sm"
                  class="float-right mx-2"
                >
                  <font-awesome-icon icon="plus" /> Cadastrar</b-button
                >
              </b-col>
            </b-row>
          </template>
          <b-overlay :show="overlayCadastro">
            <b-card-body>
              <b-container>
                <b-row style="text-align: left">
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      label="Cargo"
                      v-slot="defaultState"
                    >
                      <b-form-select
                        v-model="campos.IdEditalCargo"
                        :state="defaultState.state"
                        :options="listaCargos"
                        @change="atualizaListaTipoClassificado"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      label="Tipo de classificado"
                      v-slot="defaultState"
                    >
                      <b-form-select
                        v-model="campos.IdTipoClassificado"
                        :state="defaultState.state"
                        :options="TiposClassificado"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      label="N° classificação"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        v-model="campos.NrClassificacao"
                        :state="defaultState.state"
                        type="number"
                        min="1"
                        placeholder="Digite o número da classificação"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      label="CPF do classificado"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        v-model="campos.CpfClassificado"
                        :state="defaultState.state"
                        placeholder="Digite o CPF do classificado"
                      />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <default-form-validation-provider
                      label="Nome do classificado"
                      v-slot="defaultState"
                    >
                      <b-form-input
                        placeholder="Digite o nome completo do classificado"
                        :state="defaultState.state"
                        v-model="campos.NomeClassificado"
                      />
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-body>
          </b-overlay>
        </b-card>
        <b-card header-tag="header" no-body>
          <template #header>
            <header-sagres titulo="Cargos e classificados" breakpoint="xl" />
          </template>
          <b-card-body>
            <b-overlay>
              <b-table
                responsive
                :items="listarCargosClassificados"
                :fields="fields"
                striped
                show-empty
                hover
                stacked="xl"
              >
                <template #cell(show_details)="row">
                  <b-link class="text-dark" @click="row.toggleDetails">
                    <font-awesome-icon
                      :icon="
                        row.detailsShowing ? 'chevron-down' : 'chevron-right'
                      "
                    />
                  </b-link>
                </template>

                <template #row-details="row">
                  <TabelaClassificadosEdital
                    :classificados="row.item.Classificados"
                    :detalhes="detalhes"
                  />
                </template>
                <template #empty>
                  <div class="text-center text-muted">
                    Nenhum cargo encontrado.
                  </div>
                </template>
              </b-table>
            </b-overlay>
          </b-card-body>
        </b-card>

        <ModalImportarClassificados
          v-if="exibirModalImportacao"
          @fecharModal="onFecharModalImportacao"
          :idEdital="idEdital"
          :cargosEditais="listaCargos"
          :tiposClassificados="TiposClassificado"
        />
      </b-form>
    </validation-observer>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { ValidationObserver } from "vee-validate";
import { SelectValue } from "@/types/select-value";
import { Component, Ref, Vue } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import concursoService from "@/services/atos-pessoal/concursoService";
import TabelaClassificadosEdital from "./TabelaClassificadosEdital.vue";
import { EditalCargo } from "@/types/atos-pessoal/concursos/edital-cargo";
import { Classificado } from "@/types/atos-pessoal/concursos/classificado";
import { TipoClassificado } from "@/types/atos-pessoal/concursos/tipo-classificado";
import { fieldsCargosClassificados } from "@/types/atos-pessoal/concursos/fields-cargos-classificados";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import ModalImportarClassificados from "./ModalImportarClassificados.vue";
import { EditalConcurso } from "@/types/atos-pessoal/concursos/edital";

const CompProps = Vue.extend({
  name: "AbaClassificadosConcurso",
  components: {
    DefaultFormValidationProvider,
    HeaderSagres,
    ValidationObserver,
    TabelaClassificadosEdital,
    ModalImportarClassificados,
  },
  props: {
    idEdital: {
      type: Number,
      required: true,
    },
    detalhes: {
      type: Boolean,
      default: false,
    },
  },
});

@Component
export default class AbaClassificadosConcurso extends mixins(
  UtilsTS,
  CompProps
) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;

  campos = new Classificado();
  edital: EditalConcurso = new EditalConcurso();

  listaCargos: SelectValue[] = [];
  listaTiposClassificado: TipoClassificado[] = [];
  TiposClassificado: SelectValue[] = [];
  listaCargosEditais: EditalCargo[] = [];
  listarCargosClassificados: EditalCargo[] = [];

  fields: TableField[] = fieldsCargosClassificados;

  overlayCadastro = false;
  overlayTabela = false;

  exibirModalImportacao = false;

  async mounted() {
    this.campos.IdEditalCargo = null;
    this.campos.IdTipoClassificado = null;
    await this.carregarCargos();
    await this.carregarTiposClassificado();
    await this.carregarClassificados();
  }

  async carregarCargos() {
    try {
      this.overlayCadastro = true;
      this.listaCargosEditais = await concursoService.listarCargosEdital(
        this.idEdital
      );
      this.listaCargos = this.listaCargosEditais.map((cd: EditalCargo) => {
        return {
          value: cd.id_edital_cargo,
          text:
            cd.IdCargoProcessoSeletivo === null
              ? `${cd.IdCargoNavigation.DeCodigoCargo} - ${cd.IdCargoNavigation.DeNomenclaturaCargo}`
              : `Cargo temporário - ${cd.IdCargoProcessoSeletivoNavigation.DsNomenclatura}`,
        };
      });
      this.listaCargos.unshift({ text: "Selecione uma opção", value: null });
      // Se o cargo selecionado sumir apos recarregar (mudanca de tipo/cargos),
      // limpamos o campo para evitar submissao com id obsoleto.
      const cargoSelecionadoExiste = this.listaCargosEditais.some(
        (cargo) => cargo.id_edital_cargo === this.campos.IdEditalCargo
      );
      if (!cargoSelecionadoExiste) {
        this.campos.IdEditalCargo = null;
      }
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayCadastro = false;
    }
  }

  atualizaListaTipoClassificado() {
    const cargoSelecionado = this.listaCargosEditais.find(
      (x) => x.id_edital_cargo === this.campos.IdEditalCargo
    );
    this.TiposClassificado = this.TiposClassificado.map((x) => {
      if (x.text.includes("Ampla")) {
        return { ...x, disabled: cargoSelecionado?.qtd_vagas_ampla === 0 };
      } else if (x.text.includes("PCD")) {
        return { ...x, disabled: cargoSelecionado?.qtd_vagas_pcd === 0 };
      } else {
        return { ...x, disabled: cargoSelecionado?.qtd_vagas_cotas === 0 };
      }
    });
  }

  async getConcursoById() {
    try {
      const response = await concursoService.getConcursoById(this.idEdital);
      if (!response) return this.$toast.error("Erro ao encontrar edital");
      this.edital = new EditalConcurso(response);
    } catch (error: any) {
      this.tratarError(error);
    }
  }

  async carregarTiposClassificado() {
    await this.getConcursoById();
    try {
      this.overlayCadastro = true;
      this.listaTiposClassificado =
        (await concursoService.listarTipoClassificado()) as TipoClassificado[];
      this.TiposClassificado = this.listaTiposClassificado.map(
        (tc: TipoClassificado) => ({
          value: tc.IdTipoClassificado,
          text: tc.DsTipoClassificado,
          disabled: false,
        })
      );
      this.TiposClassificado.unshift({
        text: "Selecione uma opção",
        value: null,
      });
      if (!this.edital.FlVagasCotas)
        this.TiposClassificado = this.TiposClassificado.filter(
          (opt) => opt.text !== "Cotas"
        );
      if (!this.edital.FlVagasPcd)
        this.TiposClassificado = this.TiposClassificado.filter(
          (opt) => opt.text !== "PCD"
        );
      // Aplica a mesma protecao para tipo de classificado apos refiltro.
      const tipoSelecionadoExiste = this.TiposClassificado.some(
        (tipo) => tipo.value === this.campos.IdTipoClassificado
      );
      if (!tipoSelecionadoExiste) {
        this.campos.IdTipoClassificado = null;
      }
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayCadastro = false;
    }
  }

  async cadastrarClassificado() {
    try {
      this.campos.CpfClassificado = this.campos.CpfClassificado.replaceAll(
        ".",
        ""
      ).replaceAll("-", "");
      this.overlayCadastro = true;
      await concursoService.cadastrarClassificado(this.idEdital, this.campos);
      this.$toast.success("Classificado cadastrado com sucesso!");
      this.campos = new Classificado();
      this.campos.IdEditalCargo = null;
      this.campos.IdTipoClassificado = null;
      this.carregarClassificados();
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayCadastro = false;
    }
  }

  async carregarClassificados() {
    try {
      this.overlayTabela = true;
      this.listarCargosClassificados =
        await concursoService.listarClassificados(this.idEdital);
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayTabela = false;
    }
  }

  onFecharModalImportacao(refresh = false): void {
    this.exibirModalImportacao = false;
    if (refresh) this.carregarClassificados();
  }
}
</script>
